import { WidgetContentFilesDocumentsListItem } from '../WidgetContentFilesDocumentsListItem'
import { WidgetContentFilesList } from '../WidgetContentFilesList'

import { VISIBLE_ITEMS_COUNT } from './WidgetContentFilesDocumentsList.constants'
import { getDocumentItemProps } from './WidgetContentFilesDocumentsList.utils'

function WidgetContentFilesDocumentsList({
  titleKey = 'Common.ProfileWidgetDocumentsItemsTitleKey',
  visibleCount = VISIBLE_ITEMS_COUNT,
  ...restProps
}) {
  return (
    <WidgetContentFilesList
      {...restProps}
      Item={WidgetContentFilesDocumentsListItem}
      getItemPropsFromValue={getDocumentItemProps}
      titleKey={titleKey}
      visibleCount={visibleCount}
    />
  )
}

export default WidgetContentFilesDocumentsList
